import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import type { CanDeactivateFn } from '@angular/router';
import { ConfirmationDialogCloseOptionComponent } from 'src/app/shared/components/confirmation-dialog-close-option/confirmation-dialog-close-option.component';
import { ProjectWageRateFormComponent } from '../project-wage-rate-form.component';
import { map, Observable } from 'rxjs';
import { ProjectWageDataFormService } from '../services/project-wage-data-form.service';
import { ProjectRateCancelTitle } from '../enums/project-rate-form-mode.enum';

export const projectCancelConfirmationGuard: CanDeactivateFn<
  ProjectWageRateFormComponent
> = (): Observable<boolean> | boolean => {
  const _dialog: MatDialog = inject(MatDialog);
  const _projectWageDataFormService = inject(ProjectWageDataFormService);
  const currentFormMode = _projectWageDataFormService.currentFormMode();
  const modalTitle = ProjectRateCancelTitle[currentFormMode()!];
  const projectWageForm = _projectWageDataFormService.projectWageForm;

  let isUserGoingBack: Observable<boolean> = new Observable();

  if (!projectWageForm.dirty) {
    return true;
  }

  const dialogRef = _dialog.open(ConfirmationDialogCloseOptionComponent, {
    data: {
      title: modalTitle,
      body: `<p>Are you sure you want to close? Your information will not be saved.</p>`,
      cancelButton: 'Cancel',
      cancelButtonId: 'btn-add-project-wage-cancel-close-modal',
      confirmButton: 'Yes',
      confirmButtonId: 'btn-add-project-wage-confirmation-close-modal',
      className: 'modal-title',
    },

    height: 'auto',
    id: 'dialog-close-project-wage-form',
    autoFocus: false,
    width: '570px',
    disableClose: true,
  });
  isUserGoingBack = dialogRef.afterClosed().pipe(
    map((isLeavingThePage: boolean) => {
      if (isLeavingThePage) {
        _projectWageDataFormService.setIsUserLeavingThePage(true);
        return true;
      }
      _projectWageDataFormService.setIsUserLeavingThePage(false);
      return false;
    })
  );

  return isUserGoingBack;
};
